import React from 'react';

const AsyncControlList = React.lazy(() => import('./ListContainer'));

export const ControlList = () => {
  return <AsyncControlList />;
};
